import moment from 'moment';

import { OhsCusval } from './OhsCusvalModel';

// eslint-disable-next-line import/prefer-default-export
export const formattedDataCusvals = (cusvalList: OhsCusval[]) =>
  cusvalList?.map((item: any) => {
    if (item.type === 'date') {
      // Convert value to date format 'YYYY-MM-DD'
      const formattedDate = moment(new Date(item.value)).format('YYYY-MM-DD') ?? '';
      return { ...item, value: formattedDate };
    }
    return item;
  });

export const getCusvalsOptionsDepth = (options: any[] | undefined): number => {
  if (!options || options.length === 0) return 0;

  let maxDepth = 0;
  const stack: { node: any; depth: number }[] = options.map((o) => ({ node: o, depth: 1 }));

  while (stack.length) {
    const { node, depth } = stack.pop()!;
    if (depth > maxDepth) maxDepth = depth;

    const children = node?.options;
    if (children && children.length) {
      for (let i = 0; i < children.length; i += 1) {
        stack.push({ node: children[i], depth: depth + 1 });
      }
    }
  }

  return maxDepth;
};
